module.exports = __webpack_public_path__ + "img/Valentine.1ab3836f.jpg";